import React, { useState, useEffect } from "react";
import {
  FaChalkboardTeacher,
  FaBookOpen,
  FaHeadset,
  FaUserCircle,
  FaFileAlt,
  FaStar,
  FaGraduationCap,
  FaCheck,
  FaArrowRight,
  FaQuoteLeft,
  FaDownload,
  FaClock,
  FaCalendarAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { motion } from "framer-motion";
import ContactUsForm from "../components/ContactForm";
import GoogleReviews from "../components/GoogleReviews";

const IELTS = () => {
  const [activeTab, setActiveTab] = useState("writing");
  const [isVisible, setIsVisible] = useState(false);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [countdownDays, setCountdownDays] = useState(3);

  // Show notification when component mounts
  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    // Auto-rotate testimonials
    const interval = setInterval(() => {
      setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const showComingSoon = () => {
    alert("🚀 Coming Soon! Stay tuned for our Diagnostic Test.");
  };

  const scrollToForm = () => {
    document
      .getElementById("footer-form")
      .scrollIntoView({ behavior: "smooth" });
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const testimonials = [
    {
      name: "Sarah Johnson",
      score: "Band 8.5",
      comment:
        "The strategies I learned helped me achieve my target score on the first attempt!",
      image: "/testimonial1.jpg",
    },
    {
      name: "Michael Chen",
      score: "Band 7.5",
      comment:
        "The speaking practice sessions boosted my confidence significantly.",
      image: "/testimonial2.jpg",
    },
    {
      name: "Albert Enstine",
      score: "Band 8.0",
      comment:
        "The writing templates and personalized feedback were game-changers for me.",
      image:
        "data:image/jpeg;base64,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",
    },
  ];

  const features = [
    { title: "Live Practice Sessions", icon: FaHeadset },
    { title: "Personalized Feedback", icon: FaUserCircle },
    { title: "Mock Tests", icon: FaFileAlt },
    { title: "Learning Materials", icon: FaGraduationCap },
  ];

  const examSections = {
    writing: {
      icon: FaBookOpen,
      title: "Writing",
      description:
        "Master the art of IELTS Writing with our structured approach",
      text: [
        "Understand essay structures and coherence.",
        "Improve task responses with expert strategies.",
        "Learn time management techniques for Writing tasks.",
        "Master different writing styles and formats.",
        "Enhance vocabulary and grammar for better scores.",
        "Analyze sample high-scoring responses for insights.",
      ],
    },
    listening: {
      icon: FaHeadset,
      title: "Listening",
      description: "Sharpen your listening skills with targeted practices",
      text: [
        "Develop active listening skills for different accents.",
        "Understand various question types and how to answer them.",
        "Practice with real exam-style recordings.",
        "Identify keywords and key ideas effectively.",
        "Improve note-taking skills for better accuracy.",
        "Learn how to manage time efficiently during the test.",
      ],
    },
    speaking: {
      icon: FaChalkboardTeacher,
      title: "Speaking",
      description: "Build confidence and fluency in your speaking abilities",
      text: [
        "Enhance fluency and pronunciation with expert guidance.",
        "Get tips on structuring your responses effectively.",
        "Engage in mock interviews for real exam practice.",
        "Learn how to handle difficult questions confidently.",
        "Understand common IELTS speaking topics and themes.",
        "Develop strategies to manage nervousness during the test.",
      ],
    },
    reading: {
      icon: FaBookOpen,
      title: "Reading",
      description:
        "Develop strategic approaches to tackle IELTS reading questions",
      text: [
        "Learn effective skimming and scanning techniques.",
        "Understand different question types and strategies.",
        "Practice with authentic IELTS reading passages.",
        "Develop critical reading and analytical skills.",
        "Improve reading speed without sacrificing comprehension.",
        "Master time management for the reading section.",
      ],
    },
  };

  const resources = [
    {
      title: "IELTS Writing Task 1 Guide",
      description: "Complete guide with templates and examples",
      icon: FaFileAlt,
      format: "PDF",
    },
    {
      title: "Speaking Practice Cards",
      description: "100+ practice questions for Part 2 speaking",
      icon: FaChalkboardTeacher,
      format: "PDF",
    },
    {
      title: "Vocabulary Booster",
      description: "Essential academic vocabulary by topic",
      icon: FaBookOpen,
      format: "PDF",
    },
  ];

  const nextTestimonial = () => {
    setTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5E8D8] to-[#E8D5C0] font-sans">
      {/* Notification
      {isVisible && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="fixed top-6 right-6 bg-primary-blue text-white p-4 rounded-lg shadow-lg z-50 flex items-center gap-3 max-w-xs"
        >
          <FaStar className="text-yellow-300 text-xl" />
          <p className="text-sm">Limited-time offer: 20% off on all IELTS preparation courses!</p>
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-1 right-1 text-white text-xs p-1"
          >
            ✕
          </button>
        </motion.div>
      )} */}

      {/* Hero Section with Background Image */}
      <div className="relative min-h-[75vh] flex items-center">
        {/* Background Image with Blur */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat blur-md"
          style={{
            backgroundImage:
              "url('https://www.shutterstock.com/image-photo/word-ielts-on-wooden-cubes-260nw-2043623789.jpg')",
          }}
        ></div>

        {/* Dark Overlay for Better Readability */}
        <div className="absolute inset-0 bg-black/30"></div>

        {/* Content Section (Text and Buttons) */}
        <div className="container mx-auto px-6 py-16 relative z-10 text-center text-white">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-6xl font-light mb-4">
              Master the IELTS
            </h1>
            <p className="text-xl md:text-2xl mt-3 max-w-3xl mx-auto font-light leading-relaxed">
              Your pathway to international opportunities through proven
              strategies and expert guidance.
            </p>

            <div className="mt-10 flex flex-wrap justify-center gap-6">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToForm}
                className="bg-primary-blue text-white px-6 py-3 text-lg font-medium rounded-full hover:bg-primary-dark transition shadow-lg flex items-center gap-2"
              >
                Start Free Trial <FaArrowRight />
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={showComingSoon}
                className="bg-primary-brown text-white px-6 py-3 text-lg font-medium rounded-full hover:bg-primary-dark transition shadow-lg"
              >
                Take Diagnostic Test
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* IELTS Introduction */}
      <div className="container mx-auto px-6 py-12">
        <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 md:p-12">
          <h2 className="text-3xl text-primary-dark mb-6 text-center">
            Why the <span className="text-primary-blue font-medium">IELTS</span>{" "}
            Matters
          </h2>
          <p className="text-primary-dark text-lg mt-4 leading-relaxed">
            The International English Language Testing System (IELTS) is a
            globally recognized exam assessing English proficiency. It is
            essential for individuals aiming to study, work, or migrate to
            English-speaking countries.
          </p>
          <p className="text-primary-dark text-lg mt-4 leading-relaxed">
            It evaluates four key skills: Listening, Reading, Writing, and
            Speaking. The test format varies based on whether you take the
            Academic or General Training version. Understanding the structure
            and scoring system is crucial for your success.
          </p>

          {/* Features */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -5 }}
                className="flex flex-col items-center text-center p-4 rounded-xl bg-primary-blue/5 border border-primary-blue/20"
              >
                <div className="bg-primary-blue/10 p-4 rounded-full mb-4">
                  <feature.icon className="text-primary-blue text-2xl" />
                </div>
                <h3 className="font-medium text-primary-dark">
                  {feature.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Meet the Mentor Section */}
      {/* <div className="container mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 md:p-12 overflow-hidden"
        >
          <h2 className="text-3xl text-primary-dark mb-6 text-center">
            Meet Your{" "}
            <span className="text-primary-blue font-medium">Mentor</span>
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="md:w-1/2 space-y-4">
              <div className="flex items-center mb-4">
                <div className="h-1 bg-primary-blue w-12 mr-4"></div>
                <h3 className="text-2xl font-medium text-primary-dark">
                  John Doe
                </h3>
              </div>

              <p className="text-lg leading-relaxed">
                An IELTS expert with over 10 years of experience helping
                students achieve their target scores and reach their
                international education and career goals.
              </p>

              <ul className="space-y-3 mt-6">
                {[
                  "Certified IELTS examiner with deep understanding of assessment criteria",
                  "Developed custom strategies for over 2,000 successful students",
                  'Author of "Mastering IELTS: A Comprehensive Guide"',
                  "Regular speaker at international English language conferences",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <FaCheck className="text-primary-blue mt-1 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <button
                className="mt-6 bg-transparent border-2 border-primary-blue text-primary-blue hover:bg-primary-blue hover:text-white transition px-6 py-2 rounded-full font-medium flex items-center gap-2"
                onClick={() => window.open("#", "_blank")}
              >
                Read Full Profile <FaArrowRight />
              </button>
            </div>

            <div className="md:w-1/2 relative">
              <div className="relative z-10">
                <div className="absolute -inset-4 bg-primary-blue rounded-3xl transform rotate-3"></div>
                <img
                  src="/mentor-image.jpg"
                  alt="John Doe - IELTS Mentor"
                  className="relative z-10 w-full max-w-md h-auto object-cover rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </motion.div>
      </div> */}

      {/* Exam Sections with Interactive Tabs */}
      <div className="container mx-auto px-6 py-12">
        <h2 className="text-3xl text-primary-dark mb-12 text-center">
          IELTS{" "}
          <span className="text-primary-blue font-medium">Exam Sections</span>
        </h2>

        <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-6 md:p-10">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8">
            {Object.keys(examSections).map((section) => (
              <button
                key={section}
                onClick={() => setActiveTab(section)}
                className={`px-5 py-3 md:px-8 md:py-4 rounded-full text-lg font-medium transition ${
                  activeTab === section
                    ? "bg-primary-blue text-white shadow-lg"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {examSections[section].title}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mt-8"
          >
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-1/3 flex flex-col items-center text-center">
                <div className="bg-primary-blue/10 p-6 rounded-full mb-6">
                  {React.createElement(examSections[activeTab].icon, {
                    className: "text-primary-blue text-5xl",
                  })}
                </div>
                <h3 className="text-2xl font-semibold text-primary-dark mb-4">
                  {examSections[activeTab].title}
                </h3>
                <p className="text-gray-600">
                  {examSections[activeTab].description}
                </p>
              </div>

              <div className="md:w-2/3">
                <ul className="grid md:grid-cols-2 gap-4">
                  {examSections[activeTab].text.map((point, i) => (
                    <li
                      key={i}
                      className="bg-gray-50 p-4 rounded-lg flex items-start gap-3"
                    >
                      <div className="bg-primary-blue/10 p-2 rounded-full flex-shrink-0">
                        <FaCheck className="text-primary-blue" />
                      </div>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Testimonials Carousel */}
      <div className="container mx-auto px-6 py-12">
        <h2 className="text-3xl text-primary-dark mb-12 text-center">
          Success <span className="text-primary-blue font-medium">Stories</span>
        </h2>

        <GoogleReviews />
      </div>

      {/* Special Offer with Countdown
      <div className="container mx-auto px-6 py-12">
        <div className="bg-gradient-to-r from-primary-blue to-primary-dark text-white rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <h2 className="text-3xl mb-6">
            Limited Time <span className="font-medium">Special Offer</span>
          </h2>
          <p className="text-xl mb-8">
            Enroll now and get 20% off on our Premium IELTS Preparation Course!
          </p>
          
          <div className="flex justify-center gap-4 mb-8">
            <div className="bg-white/20 p-4 rounded-lg w-20 text-center">
              <div className="text-3xl font-bold">{countdownDays}</div>
              <div className="text-sm">Days</div>
            </div>
            <div className="bg-white/20 p-4 rounded-lg w-20 text-center">
              <div className="text-3xl font-bold">08</div>
              <div className="text-sm">Hours</div>
            </div>
            <div className="bg-white/20 p-4 rounded-lg w-20 text-center">
              <div className="text-3xl font-bold">45</div>
              <div className="text-sm">Minutes</div>
            </div>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToForm}
            className="bg-white text-primary-blue px-8 py-4 text-lg font-medium rounded-full hover:bg-gray-100 transition shadow-lg"
          >
            Claim Your Discount Now
          </motion.button>
        </div>
      </div> */}

      {/* Resources Section */}
      <div className="container mx-auto px-6 py-12">
        <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 md:p-12">
          <h2 className="text-3xl text-primary-dark mb-6 text-center">
            Free{" "}
            <span className="text-primary-blue font-medium">Resources</span>
          </h2>
          <p className="text-lg text-center mb-10">
            Download these free resources to kickstart your IELTS preparation
            journey
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {resources.map((resource, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -5 }}
                className="bg-gray-50 p-6 rounded-xl shadow-md border border-gray-100"
              >
                <div className="flex justify-between items-center mb-4">
                  <div className="bg-primary-blue/10 p-3 rounded-full">
                    <resource.icon className="text-primary-blue text-xl" />
                  </div>
                  <span className="text-sm bg-primary-brown/10 text-primary-brown px-3 py-1 rounded-full font-medium">
                    {resource.format}
                  </span>
                </div>
                <h3 className="text-xl font-medium text-primary-dark mb-2">
                  {resource.title}
                </h3>
                <p className="text-gray-600 mb-6">{resource.description}</p>
                <button
                  onClick={openModal}
                  className="w-full bg-primary-blue/10 text-primary-blue hover:bg-primary-blue hover:text-white transition px-4 py-2 rounded-lg font-medium flex items-center justify-center gap-2"
                >
                  <FaDownload /> Download
                </button>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Upcoming Courses
      <div className="container mx-auto px-6 py-12">
        <h2 className="text-3xl text-primary-dark mb-12 text-center">
          Upcoming <span className="text-primary-blue font-medium">Courses</span>
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {[
            {
              title: "IELTS Academic Intensive",
              date: "March 15, 2025",
              duration: "8 weeks",
              highlights: [
                "Comprehensive coverage of all four modules",
                "Weekly mock tests with detailed feedback",
                "Small group sessions (max 8 students)"
              ]
            },
            {
              title: "IELTS Writing Masterclass",
              date: "April 5, 2025",
              duration: "4 weeks",
              highlights: [
                "Task 1 & 2 strategies and templates",
                "Individual feedback on 8 practice essays",
                "Advanced vocabulary and grammar review"
              ]
            }
          ].map((course, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -5 }}
              className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-6 md:p-8 border-t-4 border-primary-blue"
            >
              <h3 className="text-2xl font-medium text-primary-dark mb-4">{course.title}</h3>
              
              <div className="flex flex-wrap gap-4 mb-6">
                <div className="flex items-center gap-2 bg-primary-blue/10 text-primary-blue px-3 py-1 rounded-full">
                  <FaCalendarAlt />
                  <span>{course.date}</span>
                </div>
                <div className="flex items-center gap-2 bg-primary-brown/10 text-primary-brown px-3 py-1 rounded-full">
                  <FaClock />
                  <span>{course.duration}</span>
                </div>
              </div>
              
              <ul className="space-y-2 mb-6">
                {course.highlights.map((highlight, j) => (
                  <li key={j} className="flex items-start gap-2">
                    <FaCheck className="text-primary-blue mt-1 flex-shrink-0" />
                    <span>{highlight}</span>
                  </li>
                ))}
              </ul>
              
              <div className="flex justify-between items-center">
                <button
                  onClick={scrollToForm}
                  className="bg-primary-blue text-white px-5 py-2 rounded-lg hover:bg-primary-dark transition"
                >
                  Enroll Now
                </button>
                <button
                  onClick={() => window.open("#", "_blank")}
                  className="text-primary-blue hover:underline"
                >
                  Learn more
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div> */}

      {/* Contact Form Section - Full Width */}
      <div id="footer-form" className="bg-[#FAEEDC] py-16 flex justify-center">
        <div>
          {/* Start Your IELTS Journey Section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mb-12 bg-[#FAEEDC]"
          >
            <h2 className="text-3xl mb-4 text-brown-700">
              Start Your IELTS Journey{" "}
              <span className="font-medium">Today</span>
            </h2>
            <p className="text-lg opacity-90 text-brown-700">
              Take the first step towards achieving your target IELTS score. Our
              expert mentors are ready to guide you.
            </p>
          </motion.div>

          {/* Expanded Form Box - Full Merge */}
          <div className="p-10 w-full bg-[#FAEEDC] text-primary-dark rounded-lg">
            <h2 className="text-2xl font-bold mb-6 text-center text-brown-700">
              Book your FREE consultation with Certified Counsellors
            </h2>
            <ContactUsForm />
          </div>
        </div>
      </div>

      {/* Email Signup Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 0, opacity: 0 }}
            className="bg-white rounded-2xl p-8 max-w-md w-full relative"
          >
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>

            <h3 className="text-2xl font-medium text-primary-dark mb-4">
              Download Free Resources
            </h3>
            <p className="text-gray-600 mb-6">
              Enter your email to receive our free IELTS preparation resources.
            </p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert("Thank you! Resources have been sent to your email.");
                closeModal();
              }}
            >
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-blue focus:border-primary-blue"
                  placeholder="your@email.com"
                />
              </div>

              <div className="flex items-center mb-4">
                <input type="checkbox" id="newsletter" className="mr-2" />
                <label htmlFor="newsletter" className="text-sm text-gray-600">
                  I want to receive weekly IELTS tips and updates
                </label>
              </div>

              <button
                type="submit"
                className="w-full bg-primary-blue text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition"
              >
                Download Resources
              </button>
            </form>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default IELTS;
